import {type FunctionalComponent, h} from '@stencil/core';
import type {GuidedApiQuickLink} from '../api';
import {Chips} from './chips';
import { mapStatusToColor, mapStatusToIcon } from './utils';

export interface QuickOrderLinkProps{
    guidedlinkitem: GuidedApiQuickLink,
    clickHandler: CallableFunction,
    labelProvider?: CallableFunction,
}

export const QuickOrderLink:FunctionalComponent<QuickOrderLinkProps> = (props) => {

    const {clickHandler, guidedlinkitem:link, labelProvider} = props;
    let orderStatusKey = link._original.status;
    if(orderStatusKey != null && orderStatusKey != undefined)
    {
      const trimmedStatus = orderStatusKey.replace(',', '').replace(/\s/g, '');
      orderStatusKey = `orders.status.${trimmedStatus}`;
    }

    //TODO: add external link icon
    return <li class="guided-pane__quick-links-section-item guided-pane_item">
      <a
        class="guided-pane__quick-link"
        href={link.openUrl}
        onClick={e => clickHandler(link, e, 'quicklinks')}
        onContextMenu={e => clickHandler(link, e, 'quicklinks')}
      >
        <div class='guided-pane__quick-link-container'>
          <p class="guided-pane__quick-link-p">
            {link.chips && link.chips.beforeTitle ? <Chips chips={link.chips.beforeTitle}></Chips> : ''}
            <span class='guided-pane__quick-link-text' innerHTML={link.markup || link.title}/>

            {link.chips && link.chips.afterTitle ? <Chips chips={link.chips.afterTitle}></Chips> : ''}
          </p>

        </div>
        <div class="guided-pane__quick-link-description">
          <svs-status
            class="guided-pane__quick-link-status"
            label={labelProvider(orderStatusKey, link._original.status)}
            color={mapStatusToColor(link._original.status)}
            type={mapStatusToIcon(link._original.status)}
            privateCard={true}
          ></svs-status>
          <span> | {labelProvider('po', 'PO')} {link._original.customerPONumber}</span></div>
      </a>
    </li>;
};
